export default {"src":"/_next/static/media/starlight-logo.8e1f70aa.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};